// ChangeInformationModal.jsx
import React, { useState } from "react";
import "./change-information.css";
import { IoClose } from "react-icons/io5";
import { ClipLoader } from "react-spinners";
import { updateInformation } from "../../api/user.api";
import { showTopCenterToast } from "../toasts/ToastNotification";

const FloatingInput = ({ label, value, onChange, disabled = false }) => {
  const hasValue = value && value.trim() !== "";

  return (
    <div className={`cimodal-field ${hasValue ? "has-value" : ""}`}>
      <label className="cimodal-label">{label}</label>
      <input
        className="cimodal-input"
        placeholder=" "
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

const ChangeInformationModal = ({ isOpen, onClose, user, setUser }) => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(null);

  React.useEffect(() => {
    if (!isOpen) return;
    setUsername(user?.username || "");
    setFullName(user?.fullName || "");
    setPhone(user?.phone || "");
    setError(null);
  }, [isOpen, user?.username, user?.fullName, user?.phone]);

  if (!isOpen) return null;

  const handleUpdateInformation = async () => {
    setError(null);
    try {
      setLoading(true);
      const res = await updateInformation(username, fullName, phone);
      if (res.success) {
        showTopCenterToast("Cập nhật thông tin thành công", "success");
        setUser(res.data.updatedUser);
        onClose();
      }
    } catch (error) {
      setError({ message: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cimodal-overlay" onClick={onClose}>
      <div className="cimodal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="cimodal-head">
          <h2 className="cimodal-title">Thay đổi thông tin</h2>
          <button className="cimodal-close-btn" onClick={onClose} type="button" aria-label="Đóng modal">
            <IoClose />
          </button>
        </div>
        <div className="cimodal-body">
          <FloatingInput label="Họ và tên" value={fullName} onChange={(e) => setFullName(e.target.value)} />
          <FloatingInput label="Tên đăng nhập" value={username} onChange={(e) => setUsername(e.target.value)} />
          <FloatingInput label="Email" value={user?.email || ""} disabled />
          <FloatingInput label="Số điện thoại" value={phone} onChange={(e) => setPhone(e.target.value)} />
        </div>
        {error && <p className="cimodal-error">*{error?.message}</p>}
        <button
          onClick={handleUpdateInformation}
          disabled={loading}
          className={`cimodal-submit-btn ${loading ? "disabled-button" : ""}`}
          type="button"
        >
          {loading ? <ClipLoader size={20} color="#fff" /> : "Lưu thay đổi"}
        </button>
      </div>
    </div>
  );
};

export default ChangeInformationModal;
